export const updateUploadAction = (actions) => {
    return (dispatch, getState) => {
        dispatch({ type: 'UPLOAD_ACTION_UPDATE', actions })
    }
}
